import React, { Component } from 'react'
import { map, includes } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { logoutUser } from '../../redux/actions/authActions'
import Header from '../layout/Partials/Header'

import { Theme } from '../../utils/Theme'
import { withStyles } from '@material-ui/styles'
import { Grid, Typography } from '@material-ui/core'
import AdminLayout from '../layout/AdminLayout'
import { AdminCards } from '../../utils/Constants'
import SectionCard from '../common/SectionCard'

const styles = Theme()

class Settings extends Component {
  onLogoutClick(e) {
    e.preventDefault()
    this.props.logoutUser()
  }

  componentDidMount() {
    if (!this.props.auth.isAuthenticated) {
      this.props.history.push('/login')
    }
  }

  render() {
    const { user } = this.props.auth
    // const { classes } = this.props

    return (
      <AdminLayout>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">Admin</h2>
          </Header>
          <div className="u-m-xsmall">
            <Grid container spacing={2} className="u-justify-center">
              <Grid item lg={6} className="u-text-center">
                <h2 className="u-mb-small">Hello {user.name}</h2>

                <Typography variant={'p'} className="u-text-large u-mb-large">
                  {user.role === 'Admin'
                    ? 'Configure and administer your Coeus site, including managing Qlik Sense connections, groups, users and pages.'
                    : 'Manage your Coeus account'}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="u-m-auto">
              {map(AdminCards, ({ title, url, icon, description, active, roles }, index) => {
                return (
                  includes(roles, user.role) &&
                  active && (
                    <Grid item md={4} xl={3} sm={6} xs={12} key={index}>
                      <SectionCard
                        title={title}
                        AvatarIcon={icon}
                        content={description}
                        actions={[{ label: title, onClick: () => this.props.history.push(url), Icon: 'FolderOpen' }]}
                      />
                    </Grid>
                  )
                )
              })}
            </Grid>
          </div>
        </div>
      </AdminLayout>
    )
  }
}

Settings.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  classes: PropTypes.object,
  history: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
})

export default connect(mapStateToProps, { logoutUser })(withStyles(styles)(Settings))
